import { useCallback, useMemo, useState } from 'react';
import { LayoutChangeEvent, LayoutRectangle, StyleSheet, View } from 'react-native';

import { ActionSheet, Text } from '@fhs/ui';
import QrCode from '@fhs-legacy/frontend/src/pages/in-store-rewards/qr-code';

export function EarnTab() {
  const [layout, setLayout] = useState<LayoutRectangle>();

  const onLayout = useCallback((event: LayoutChangeEvent) => {
    setLayout(event.nativeEvent.layout);
  }, []);

  const options = useMemo(() => (layout ? { width: layout.width - 64 } : undefined), [layout]);

  return (
    <ActionSheet.ScrollView
      style={styles.tab}
      contentContainerStyle={styles.scrollContent}
      showsVerticalScrollIndicator={false}
    >
      <Text.Heading type="two">Collect Points In-Restaurant!</Text.Heading>
      <Text.Ui size="md" style={styles.description}>
        Present this QR Code to the cashier to earn:
      </Text.Ui>
      <View style={styles.qrCodeContainer} onLayout={onLayout}>
        <QrCode
          ignoreExpiration
          options={options}
          phoneDisclaimer="Or use your phone number instead:"
        />
      </View>
    </ActionSheet.ScrollView>
  );
}

const styles = StyleSheet.create({
  tab: {
    flex: 1,
    paddingVertical: 24,
    paddingHorizontal: 16,
  },
  scrollContent: {
    alignItems: 'center',
    paddingBottom: 32,
  },
  description: {
    marginTop: 8,
  },
  qrCodeContainer: {
    width: '100%',
    marginTop: 16,
    flex: 1,
  },
});
